import { render } from "./YouryModalLink.vue?vue&type=template&id=75a72521"
import script from "./YouryModalLink.vue?vue&type=script&lang=js"
export * from "./YouryModalLink.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/youry.co/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__